import { render } from "./UserAgreement.vue?vue&type=template&id=0c2080fc&scoped=true"
const script = {}

import "./UserAgreement.vue?vue&type=style&index=0&id=0c2080fc&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2080fc"]])

export default __exports__